let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5uk7G")).then(() => parcelRequire('1hqzj'));